import { render, staticRenderFns } from "./gasStation.vue?vue&type=template&id=c4c99724&scoped=true"
import script from "./gasStation.vue?vue&type=script&lang=js"
export * from "./gasStation.vue?vue&type=script&lang=js"
import style0 from "./gasStation.vue?vue&type=style&index=0&id=c4c99724&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4c99724",
  null
  
)

export default component.exports